import WS from './index'

export default (function () {
  var UlocWebSocket = function (uri, callbackSuccess) {
    this._uri = uri
    this._callbackSuccess = callbackSuccess
    this._service = WS
    this._session = null
    this._socketQueue = []

    this.conectar()
  }

  UlocWebSocket.prototype.transmiteMensagem = function (canal, mensagem) {
    console.log('Transmitindo mensagem ', canal, mensagem)
    let token = Math.random().toString(36).substr(2)
    this._socketQueue.push(token)
    mensagem.token = token
    this._session.publish(canal, mensagem)
  }

  UlocWebSocket.prototype.inscrever = function (canal, callback) {
    this._session.subscribe(canal, function (uri, payload) {
      callback(uri, payload)
    })
  }

  UlocWebSocket.prototype.conectar = function () {
    let webSocket = this._service.connect(this._uri)
    webSocket.on('socket/connect', (session) => {
      this._session = session
      this._callbackSuccess(session)
      // console.log('Conectado com sucesso no WS!')
    })

    webSocket.on('socket/disconnect', function (error) {
      console.log('Disconnected for ' + error.reason + ' with code ' + error.code)
    })
  }

  return {
    connect: function (uri, callbackSuccess) {
      return new UlocWebSocket(uri, callbackSuccess)
    }
  }
})()



// WEBPACK FOOTER //
// ./src/domain/ws/service.js